module.exports = __webpack_public_path__ + "img/securityImg8.1ff2dbf8.png";